import { Link } from "office-ui-fabric-react"

const ExtensionsSettingsTooltip = () => {
    return <div>
        Configure extensions to expand PPM Express functionality.
        <br />
        Please refer to <Link href="https://help.ppm.express/89495-ppm-express-settings/522610" target="_blank">this article</Link> for more details.
    </div>
}

export default ExtensionsSettingsTooltip;